export default "__VITE_ASSET__BNVvBtPj__"